module.exports = __webpack_public_path__ + "img/专业团队.73d124e7.jpg";